import React from "react";
import styled, { keyframes } from "styled-components";

// MAPA DE PERMISSÕES CORRIGIDO
const PERMISSIONS_MAP = {
  admin: "Gerenciar Administradores",
  client: "Gerenciar Clientes",
  contract: "Gerenciar Contratos",
  consultant: "Gerenciar Consultores",
  contract_validation: "Validar Contratos",
  withdraw: "Gerenciar Saques",
  withdraw_validation: "Validar Saques",
  indication: "Gerenciar Indicações",
  news: "Gerenciar Notícias",
  messages: "Gerenciar Mensagens",
  audit: "Visualizar Auditoria",
  data_extract: "Extrair Dados",
  receiving_accounts: "Contas de Depósito",
};

const getTruePermissions = (permissions) => {
  if (!permissions) return [];
  return Object.entries(permissions)
    .filter(([, value]) => value === true)
    .map(([key]) => PERMISSIONS_MAP[key] || key);
};

export default function ModalPermissionsViewer({ user, onClose }) {
  if (!user) return null;

  const viewPermissions = getTruePermissions(user.viewPermissions);
  const editPermissions = getTruePermissions(user.editPermissions);

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <h3>Permissões de {user.name}</h3>
          <CloseButton onClick={onClose}>&times;</CloseButton>
        </ModalHeader>
        <ModalBody>
          <PermissionsGrid>
            <PermissionsBox>
              <h4>Visualização</h4>
              {viewPermissions.length > 0 ? (
                <PermissionsList>
                  {viewPermissions.map((perm) => (
                    <li key={perm}>{perm}</li>
                  ))}
                </PermissionsList>
              ) : (
                <NoPermissionsMessage>
                  Nenhuma permissão de visualização concedida.
                </NoPermissionsMessage>
              )}
            </PermissionsBox>
            <PermissionsBox>
              <h4>Edição</h4>
              {editPermissions.length > 0 ? (
                <PermissionsList>
                  {editPermissions.map((perm) => (
                    <li key={perm}>{perm}</li>
                  ))}
                </PermissionsList>
              ) : (
                <NoPermissionsMessage>
                  Nenhuma permissão de edição concedida.
                </NoPermissionsMessage>
              )}
            </PermissionsBox>
          </PermissionsGrid>
        </ModalBody>
      </ModalContainer>
    </ModalOverlay>
  );
}

// Estilos
const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideIn = keyframes`from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; }`;
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2001;
  animation: ${fadeIn} 0.2s ease-out;
`;
const ModalContainer = styled.div`
  background: #282828;
  border-radius: 8px;
  width: 100%;
  max-width: 700px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.4);
  animation: ${slideIn} 0.3s ease-out;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;
const ModalHeader = styled.div`
  padding: 20px 25px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
    color: #e6aa3a;
    font-size: 20px;
  }
`;
const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.2s;
  &:hover {
    opacity: 1;
    transform: rotate(90deg);
  }
`;
const ModalBody = styled.div`
  padding: 30px 25px;
`;
const PermissionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
`;
const PermissionsBox = styled.div`
  h4 {
    margin: 0 0 15px;
    color: #fff;
    font-size: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 10px;
  }
`;
const PermissionsList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  li {
    color: #ccc;
    font-size: 14px;
  }
`;
const NoPermissionsMessage = styled.p`
  color: #888;
  font-style: italic;
  font-size: 14px;
  margin: 0;
`;
